import isEmpty from "lodash/isEmpty";

const dealSize = (range = {}) => {
  if (isEmpty(range)) return null;

  return {
    ...range,
    to: range.to || range.from,
    from: range.from || range.to,
  };
};

export default dealSize;
